import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
} from 'react-bootstrap';

class TourRosterToolbar extends React.Component {

  constructor(props) {
    super(props);
    //this.handleAddGroup = this.handleAddGroup.bind(this);
  }
  // handleAddGroup(e) {
  //   e.preventDefault();
  //   const payload = {
  //     name: `Group ${this.props.tour.groups.length}`,
  //     tour: this.props.tour.id,
  //   };
  //   this.props.newGroup(payload);
  // }
  render() {
    if (this.props.readOnly) {
      return null;
    }
    const canAddMember = (this.props.tour.groups.length > 0);
    
    return (
      <ButtonToolbar>
        <Button bsStyle="success" onClick={this.props.handleAddGroup}>
          <i className="fa fa-group" /> Add Group
        </Button>
         { canAddMember && (
          <Button bsStyle="success" onClick={this.props.handleAddMember}>
            <i className="fa fa-user-plus" /> Add Member
          </Button>
        )
        }
        <Button bsStyle="success" onClick={this.props.handleShowImport}>Import Roster</Button>
      </ButtonToolbar>
    );
  }
}
TourRosterToolbar.propTypes = {
  tour: PropTypes.object.isRequired,
  newGroup: PropTypes.func.isRequired,
  handleAddMember: PropTypes.func.isRequired,
  handleShowImport: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
TourRosterToolbar.defaultProps = {
  readOnly: false,
};

export default TourRosterToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRosterToolbar.js